module.exports = __webpack_public_path__ + "static/media/game-background-semantics.aaa59380.jpg";